import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SVGElement from './SVGElement';

export default class Twitter extends Component {
  static propTypes = {
    className: PropTypes.string,
    height: PropTypes.string,
    strokeColor: PropTypes.string,
    width: PropTypes.string,
  };

  static defaultProps = {
    height: '16px',
    strokeColor: '#333333',
    width: '16px',
  };

  render() {
    const { className, height, strokeColor, width } = this.props;

    return (
      <SVGElement
        className={className}
        height={height}
        viewBox="0 0 16 16"
        width={width}
      >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-73.000000, -321.000000)" fill={strokeColor}>
            <g transform="translate(28.000000, 320.000000)">
              <g transform="translate(45.000000, 1.000000)">
                <path d="M16.2148254,0.256890562 C15.553232,0.658476847 14.8221847,0.9505396 14.0408278,1.10681098 C13.4184136,0.425628036 12.5288688,0 11.5440474,0 C9.65632477,0 8.12433097,1.57072773 8.12433097,3.50786956 C8.12433097,3.78256883 8.15371533,4.04969939 8.21248406,4.30658995 C5.36932439,4.16011336 2.84894749,2.76524658 1.16068231,0.640222925 C0.865948254,1.1602371 0.697655997,1.76350696 0.697655997,2.40551075 C0.697655997,3.62229049 1.30137108,4.69615536 2.21985501,5.32524785 C1.65977126,5.30832958 1.13129795,5.14894168 0.66916207,4.88759894 L0.66916207,4.93078505 C0.66916207,6.6310711 1.84854352,8.04953441 3.41481908,8.37053631 C3.12809894,8.45290157 2.82535096,8.49386159 2.51325342,8.49386159 C2.2928707,8.49386159 2.07783059,8.47293636 1.86946875,8.43197634 C2.30489157,9.82506225 3.56752872,10.8397132 5.06479555,10.8664262 C3.89431845,11.8080615 2.41842206,12.3690357 0.816083882,12.3690357 C0.540048963,12.3690357 0.267130567,12.3530078 0,12.3209522 C1.51373988,13.3146779 3.31286425,13.8956869 5.24421824,13.8956869 C11.5373692,13.8956869 14.9775657,8.55129466 14.9775657,3.91524367 C14.9775657,3.76253403 14.9748944,3.61026961 14.9691065,3.46067649 C15.6373782,2.96559451 16.2179419,2.3485229 16.6747352,1.64507907 C16.0621158,1.9237853 15.4023033,2.11255757 14.7104351,2.19714891 C15.4169954,1.76350696 15.9592705,1.07564575 16.2148254,0.256890562" />
              </g>
            </g>
          </g>
        </g>
      </SVGElement>
    );
  }
}
